// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XUufm","footer":"styles_footer__3qqGU","passCodeTooltip":"styles_passCodeTooltip__1f8Ig"};